import {
  Box,
} from "@mui/material";
import { colors } from "styles/colors";
import PageHeader from "components/common/PageHeader/PageHeader";
import { RegistryPatientProvider } from "context/RegistryPatientContext";
import { RegistryProvider, useRegistryContext } from "context/RegistryContext";
import { useParams } from "react-router-dom";
import RegistryInvitations from "components/registry/RegistryInvitations/RegistryInvitations";

export default function RegistryInvitationsPage() {
  const { registryId, patientId } = useParams();

  return (
    <RegistryProvider registryId={Number(registryId)}>
      <RegistryPatientProvider>
        <CreateRegistryPageWrapper />
      </RegistryPatientProvider>
    </RegistryProvider>
  )
}

function CreateRegistryPageWrapper() {
  const { registry } = useRegistryContext();


  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: colors.topBackground,
        p: 3,
      }}>
      <Box>
        {registry && <PageHeader
          title={registry?.name}
          showPath
          buttons={[]}
        />}
      </Box>

      <Box mt={registry ? 3 : 0} minHeight={0} flex={1} display="flex">
        <RegistryInvitations />
      </Box>
    </Box>
  );
}